import template from './insurance-retention.html';
import { PAGE_TITLE } from './insurance-retention.config';
import { ITEM_KINDS, ITEM_DEFINITION_CODES } from '../../../constants';
import { actions, selectors } from '../../../state';
import './insurance-retention.global.css';
import { trackEngagement } from '@mover-app/engagement';

const POLICY_TYPES = {
  AUTO: 'auto',
  HOME: 'home',
  CONDO: 'condo',
  RENTERS: 'renters',
  MULTI: 'multi',
};

const ONLINE_POLICY_TEXT = {
  [POLICY_TYPES.AUTO]: `Based on your policy, great news, your address can be updated online.`,
  [POLICY_TYPES.HOME]: `Based on your policy, great news, your address can be updated online and a customer service representative will contact you with a re-write.`,
  [POLICY_TYPES.CONDO]: `Based on your policy, great news, your address can be updated online and a customer service representative will contact you with a re-write.`,
  [POLICY_TYPES.RENTERS]: `Based on your policy, great news, your address can be updated online and a customer service representative will contact you with a re-write.`,
  [POLICY_TYPES.MULTI]: `Based on your policies, great news, your address can be updated online and a customer service representative will contact you with a re-write (if necessary).`,
};

const PHONE_POLICY_TEXT = `Because you're moving to a new state, you'll need to call Liberty Mutual to update your policy.`;
const CUSTOMER_SERVICE_PHONE = '888-542-6683';
const RETENTION_LINK =
  'https://eservice.libertymutual.com/PmInternetContentServiceWeb/insurance/url?uri=changeAddress';

export class InsuranceRetentionController {
  constructor(updStore) {
    'ngInject';
    Object.assign(this, {
      updStore,
      customerServicePhone: CUSTOMER_SERVICE_PHONE,
      retentionLink: RETENTION_LINK,
    });
  }

  $onInit() {
    const { dispatch, connect } = this.updStore;

    this.disconnect = connect(mapStateToThis)(this);
    trackEngagement({
      code: ITEM_DEFINITION_CODES.INSURANCE_RETENTION,
      name: 'Liberty Mutual Insurance Retention',
    });

    // We're manually calling `page` here since we need to pass properties that are
    // derived within this controller.
    dispatch(actions.analytics.page(PAGE_TITLE, this.analyticsProperties));
  }

  $onDestroy() {
    this.disconnect();
  }

  get analyticsProperties() {
    return {
      'Contact Action': this.isInStateMove ? 'External Link' : 'Phone Number',
      'Contact Info': this.isInStateMove
        ? this.retentionLink
        : this.customerServicePhone,
      'In State': this.isInStateMove,
      Policies: this.policies,
      'Policy Type': this.policyType,
    };
  }

  get policyText() {
    return this.isInStateMove
      ? ONLINE_POLICY_TEXT[this.policyType]
      : PHONE_POLICY_TEXT;
  }

  get policyType() {
    return this.policies.length > 1 ? POLICY_TYPES.MULTI : this.policies[0];
  }
}

export const InsuranceRetentionComponent = {
  template,
  controller: InsuranceRetentionController,
};

function mapStateToThis(state) {
  const itemDefinition = selectors.itemDefinition.byCode(
    ITEM_KINDS.INSURANCE_RETENTION
  );
  const move = selectors.current.move(state);
  const fromAddress = move.fromAddress(state);
  const toAddress = move.toAddress(state);

  return {
    headerTitle: itemDefinition.shortDescription(state),
    isInStateMove: fromAddress.state === toAddress.state,
    policies: itemDefinition.lineOfBusiness(state) || [],
    fromAddress,
    toAddress,
  };
}
